import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Typography,
    TextField,
    Grid,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useStressEntryContext } from "./StressEntryContext";

export const StressStartConfirmDialog = ({ open, onClose, onSubmit, title, content }: any) => {

    const { state, dispatch } = useStressEntryContext();

    const data = [{
        "assetName": state.selectedStressType && state.selectedStressType?.name,
        "linkedAssets": state.selectedStressLinkedAssets,
        "checkedInUnits": [
            state.checkedUnits
        ],
        "runName":
            (state.selectedStressType?.name ?? "") +
            "_" +
            (state.selectedStressProcedure?.name ?? "") +
            "_" +
            new Date().toISOString().split("T")[0]

    }]


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >

            <DialogTitle disableTypography>
                <Grid container alignItems="center" justifyContent="space-between" >
                    <Grid item>
                        <Typography variant="h6">


                            {title}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>

            <Divider />

            <DialogContent>

                <Grid container spacing={2} direction="column" style={{ padding: "20px" }}>


                    {data.map((item: any) => (
                        <>
                            <Grid item>
                                <Typography variant="subtitle1" style={{ color: "#800280", fontSize: "20px" }}>
                                    Asset Name
                                </Typography>
                                <Typography style={{ marginLeft: "15px", marginTop: "10px" }}>{item.assetName}</Typography>
                            </Grid>

                            <Grid item>
                                <Typography variant="subtitle1" style={{ color: "#800280", fontSize: "20px" }}>
                                    Linked Assets under {item.assetName}
                                </Typography>
                                {console.log("state in dialog", state.checkedUnits)}
                                {item.linkedAssets.length > 0 ? (
                                    <Grid
                                        item
                                        style={{
                                            paddingTop: "8px",
                                            paddingBottom: "8px",
                                            paddingLeft: "16px",
                                            fontSize: "14px",
                                        }}
                                    >
                                        {item.linkedAssets.map((linkedAsset: any, index: number) => (
                                            <Typography
                                                key={index}
                                                style={{
                                                    color: "#000000DE",
                                                    fontSize: "14px",
                                                    marginLeft: "15px",
                                                    marginTop: "10px",
                                                    display: "block",
                                                }}
                                            >
                                                {index + 1}.{linkedAsset.sub_asset_name}

                                            </Typography>
                                        ))}
                                    </Grid>
                                ) : (
                                    <Typography
                                        style={{
                                            color: "#000000DE",
                                            fontSize: "14px",
                                            marginLeft: "15px",
                                            marginTop: "10px",
                                        }}
                                    >
                                        There are no assets linked to this asset.
                                    </Typography>
                                )}
                            </Grid>

                            <Grid item>
                                <Typography variant="subtitle1" style={{ color: "#800280", fontSize: "20px" }}>
                                    Checked-in Units: {item.checkedInUnits.length}
                                </Typography>
                                <Grid item style={{ paddingTop: "8px", paddingBottom: "8px", paddingLeft: "16px", fontSize: "14px" }}>
                                    {Array.from(state.checkedUnits.entries()).map(([key, value], index) => (
                                        <Typography key={index}>
                                            {index + 1}. {key} 
                                        </Typography>
                                    ))}
                                </Grid>
                            </Grid>

                            <Grid item>
                                <Typography variant="subtitle1" style={{ color: "#800280", fontSize: "20px" }}>
                                    Run Name
                                </Typography>
                                <Typography variant="subtitle1" style={{ color: "#FFA500", border: "1px solid #0000001F", padding: "16px", borderRadius: "4px" }}>
                                    {item.runName}
                                </Typography>
                            </Grid>
                        </>
                    ))}

                    <Grid item>
                        <Typography style={{ marginTop: "8px", marginLeft: "20px", fontSize: "16px" }}>

                            {content}
                        </Typography>

                        <Grid
                            container
                            justifyContent="center"
                            spacing={2}
                            style={{ marginTop: 24 }}
                        >
                            <Grid item>
                                <Button
                                    onClick={onClose}
                                    variant="contained"
                                    style={{ backgroundColor: "#800280", color: "#fff" }}
                                >
                                    CANCEL
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    style={{ backgroundColor: "#FBBF24", color: "#000" }}
                                    onClick={onSubmit}
                                >
                                    CONFIRM
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>


                </Grid>
            </DialogContent>


            <DialogActions>

            </DialogActions>
        </Dialog>
    );
};